app.controller("createTaskController", [
    "$scope",
    "CurrentPatient",
    "TasksAPI",
    "$modal",
    "$filter",
    "$mdDialog",
    "Session",
    'taskList',
    'PatientAPI',
    '$timeout',
    "$state",
    'patientId',
    'patientName',
    'dob',
    'createNewTask',
    'updateBadge',
    'fetchTask',
    'defaultAssigner',
    'ShareData',
    'TIMEZONE_TYPE',
    'TaskLiveUpdateService',
    '$q',
    'PRACTICE_PALETTE',
    '$animate',
    '$element',
    'PatientImportReview',
    function ($scope, CurrentPatient, TasksAPI, $modal, $filter, $mdDialog, Session, taskList, PatientAPI, $timeout, $state, patientId, patientName, dob, createNewTask, updateBadge, fetchTask, defaultAssigner, ShareData, TIMEZONE_TYPE, TaskLiveUpdateService, $q, PRACTICE_PALETTE, $animate, $element, PatientImportReview) {
        // ngAnimate holds an ng-class change for as long as any CSS animation it finds on the element, and
        // the spinner Complete shows while it saves spins without end, so its icon was left between the
        // spinner and the tick, and the button's fill and shine never ran. Nothing in the list animates
        // through ngAnimate; what fades does so with plain CSS. As the waitlist dialog does.
        const taskListShell = $element[0].querySelector(".settings-shell.tasks");
        if (taskListShell) {
            $animate.enabled(angular.element(taskListShell), false);
        }

        // Rows drawn at a time; more are added as the end of the table scrolls into view.
        const PAGE_SIZE = 60;

        // The due dates the create form offers in one click, as days from today.
        $scope.DUE_PRESETS = [
            { label: "Today", days: 0 },
            { label: "Tomorrow", days: 1 },
            { label: "1 week", days: 7 },
            { label: "2 weeks", days: 14 },
            { label: "1 month", days: 30 },
        ];

        this.$onInit = function () {
            $scope.patientName = patientName;
            $scope.dob = dob;
            $scope.createNewTask = createNewTask;
            $scope.updateBadge = updateBadge;
            $scope.notifyNav = fetchTask;
            $scope.CP = CurrentPatient;
            $scope.PA = PatientAPI;
            $scope.SD = ShareData;
            $scope.TIMEZONE_TYPE = TIMEZONE_TYPE;
            $scope.$mdDialog = $mdDialog;
            $scope.TasksAPI = TasksAPI;
            $scope.today = $filter("date")(new Date(), "dd-MMMM-yyyy");
            $scope.practiceOptions = Session.practiceOptions.filter(t => t.practiceFeatures && t.practiceFeatures.sendTasksWithinPracticeFeature);

            // Matched to today's options by id: the saved objects are from an earlier open, and a practice
            // that has since lost the tasks feature is dropped rather than kept as a selection nothing lists.
            const saved = ($scope.SD.taskFilters.selectedPractice || [])
                .map(p => $scope.practiceOptions.find(t => t.id === p.id))
                .filter(Boolean);
            if (saved.length > 0) {
                $scope.selectedPractice = saved;
            } else {
                // The current practice is not an option when it lacks the send-tasks feature; an [undefined]
                // selection would throw in mapTasks/filterLabels.
                $scope.selectedPractice = [$scope.practiceOptions.find(t => t.id === Session.practice.id)].filter(Boolean);
            }

            $scope.users = [];
            $scope.ALL_LABELS = [];
            $scope.labels = [];
            $scope.taskForm = {
                assigned_to_practice_id: Session.practice.id,
                assigned_to_user_id: defaultAssigner ? Number(defaultAssigner) : null,
            };
            $scope.allTasks = [];
            $scope.TOTAL_TASKS = [];

            // The list's filters, kept for the next time the list is opened.
            $scope.view = {
                tab: $scope.SD.taskFilters.tab || "open",
                search: $scope.SD.taskFilters.search || "",
                // null, not "": ng-options shows its "All labels" option only for a null model, and a blank otherwise
                label: $scope.SD.taskFilters.label || null,
                assignee: $scope.SD.taskFilters.assignee || "",
            };
            $scope.sort = sortFor("newest");
            $scope.state = { loading: false, error: null, loaded: false };
            $scope.rows = [];
            $scope.counts = { open: 0, done: 0 };
            $scope.people = [];
            $scope.labelNames = [];
            $scope.shown = PAGE_SIZE;
            $scope.busy = {};
            // Tasks just ticked from the list, by id: true completed, false reopened. They stay a moment, with
            // the tick showing the change, before moving to the other tab.
            $scope.settling = {};
            // Changes made on a card, by task id: what is saving ("fields", "description", "delete"), what just
            // saved, the description being written, and a delete waiting to be confirmed
            $scope.fieldBusy = {};
            $scope.fieldSaved = {};
            // Due dates being typed, by task id, where the browser can't open its date picker from the button
            $scope.typingDue = {};
            $scope.descEdit = null;
            $scope.confirmDelete = {};
            $scope.notice = null;
            $scope.createError = null;

            // Who a new task is about: the patient it was opened for, or - opened with none - one found with
            // the patient search
            $scope.taskPatient = patientId ? { id: patientId, name: patientName, dob: dob ? $filter("date")(dob, "dd/MM/yyyy") : "" } : null;
            $scope.pickingPatient = !patientId;
            $scope.patientSearch = { results: [], searched: false, loading: false };
            $scope.patientPicker = { query: "", open: false, active: -1 };

            // Consolidated data fetching into a single function call.
            if (taskList) {
                fetchTaskList();
            } else {
                fetchLabels();
            }
        };

        $scope.practices = Session.practiceOptions;

        // A page of tasks, or null if it failed - or if it has not come back in PAGE_WAIT_MS, so a request
        // the server never answers cannot keep the list loading for good. Which list was cut short is noted
        // (stalled), to say so once the list is done.
        const PAGE_WAIT_MS = 20000;
        let stalled = {};

        // The request is made inside a promise chain, so anything it throws becomes a failure the list can
        // report, rather than escaping $q - which, unlike a native Promise, does not catch a throw while a
        // promise is being made - and stopping the load half-way, loading for good.
        function withinTime(makeRequest, which) {
            return $q.resolve().then(() => $q((resolve) => {
                let settled = false;
                const finish = (value) => {
                    if (!settled) {
                        settled = true;
                        $timeout.cancel(timer);
                        resolve(value);
                    }
                };
                const timer = $timeout(() => {
                    stalled[which] = true;
                    finish(null);
                }, PAGE_WAIT_MS);
                $q.resolve().then(makeRequest).then(finish, () => finish(null));
            }));
        }

        const fetchCreatedTasks = (start, end, pagination) =>
            withinTime(() => $scope.TasksAPI.queryCreatedTasks(start, end, pagination), "practice");

        const fetchAssignedTasks = (start, end, pagination) =>
            withinTime(() => $scope.TasksAPI.queryAssignedTasks(start, end, pagination), "assigned");


        // Page after page until the server says there are no more, each page drawn as it comes (onPage).
        // The server reads 2000 tasks a page per practice, and on every page after the first it reads a
        // practice it has already finished from the start again - so with two busy practices it can go on
        // handing back pages for good. A page with no task not already had ends it, as does one that failed,
        // came back empty, or is past a sane number of pages. A newer load (generation) leaves an older one
        // to stop.
        const MAX_PAGES = 50;
        let loadGeneration = 0;

        function loopPages(fetchPage, listName, start, end, generation, onPage) {
            const seen = {};
            let pagesRead = 0;
            const read = (pagination) => fetchPage(start, end, pagination).then((result) => {
                if (generation !== loadGeneration) {
                    return;
                }
                const data = result && result.data;
                const fresh = ((data && data.tasks) || []).filter((t) => {
                    const isNew = !seen[t.task_id];
                    seen[t.task_id] = true;
                    return isNew;
                });
                pagesRead++;
                if (fresh.length) {
                    $scope[listName] = [...$scope[listName], ...fresh];
                    onPage();
                }
                const next = data && data.page_indexes;
                if (next && next.length > 0 && fresh.length > 0 && !angular.equals(next, pagination) && pagesRead < MAX_PAGES) {
                    return read(next);
                }
            });
            return read(null);
        }

        // The users and labels of each practice, worked out once when they load, so a card's pickers are
        // handed the same list on every digest
        const NONE = [];
        let usersByPractice = {};
        let labelsByPractice = {};

        $scope.usersForPractice = (practiceId) => usersByPractice[practiceId] || NONE;

        $scope.filteredUsers = [];

        $scope.filteredLabels = [];

        $scope.filterOptions = () => {
            $scope.filteredUsers = $scope.users.filter(t => t.practiceId === $scope.taskForm.assigned_to_practice_id);
            $scope.filteredLabels = $scope.ALL_LABELS.filter(t => t.practice_id === $scope.taskForm.assigned_to_practice_id);

            // A choice from another practice would be sent unseen - the select can't show it - so it goes.
            if ($scope.users.length && !$scope.filteredUsers.some(u => u.value === $scope.taskForm.assigned_to_user_id)) {
                $scope.taskForm.assigned_to_user_id = null;
            }
            if ($scope.ALL_LABELS.length && !$scope.filteredLabels.some(l => l.task_label_id === $scope.taskForm.task_label_id)) {
                $scope.taskForm.task_label_id = null;
            }
        }

        // One row per user per practice. `name` is the person alone: the practice is chosen as its own field,
        // in the new task form and on each card. The signed-in user goes by their name too, listed first.
        function toUserOption(doc) {
            const person = `${doc.firstName} ${doc.lastName}`;
            return { name: person, value: doc.id, practiceId: doc.practiceId, person: person, practiceName: doc.practiceName, isMe: Session.user.id === doc.id };
        }

        function sortUserOptions(users) {
            users.sort(function (a, b) {
                if (a.isMe !== b.isMe) return a.isMe ? -1 : 1;
                return a.name.localeCompare(b.name);
            });
            return users;
        }

        // The server's task-users list only has certain roles, so the signed-in user can be missing from it -
        // and so from their own practices' pickers. They are added to every practice they are in: a task can
        // be assigned to them there whatever their role.
        function setUsers(docs) {
            const users = docs.map(toUserOption);
            const me = Session.user;
            (Session.practiceOptions || []).forEach((p) => {
                if (!users.some(u => u.isMe && u.practiceId === p.id)) {
                    users.push(toUserOption({ id: me.id, firstName: me.firstName, lastName: me.lastName, practiceId: p.id, practiceName: p.name }));
                }
            });
            $scope.users = sortUserOptions(users);
            usersByPractice = {};
            $scope.users.forEach(u => (usersByPractice[u.practiceId] = usersByPractice[u.practiceId] || []).push(u));
        }

        // Labels come back in each practice's own order
        function setLabels(labels) {
            $scope.ALL_LABELS = angular.copy(labels);
            labelsByPractice = {};
            $scope.ALL_LABELS.forEach(l => (labelsByPractice[l.practice_id] = labelsByPractice[l.practice_id] || []).push(l));
        }

        function fetchTaskList() {
            $scope.allTasks = [];
            $scope.assignedTasks = [];
            $scope.createdTasks = [];
            $scope.TOTAL_TASKS = [];
            const dueDateWindow = taskDateWindow();
            const generation = ++loadGeneration;
            stalled = {};
            $scope.state.loading = true;
            $scope.state.loaded = false;
            $scope.state.error = null;

            // The list is drawn as soon as the users and labels it needs are in, and again as each page of
            // tasks arrives - not held back until the last page, which with many tasks is a long wait. A
            // failure before anything is drawn says so in place of the list, with Try again; one after, above
            // it, as the tasks already drawn are still right.
            let ready = false;
            const draw = () => {
                if (!ready || generation !== loadGeneration) {
                    return;
                }
                mergeFetchedTasks();
                mapTasks();
                filterLabels($scope.selectedPractice.map(t => t.id));
                rebuildList();
                $scope.state.loaded = true;
            };

            // $q rather than native Promise: native callbacks run outside a digest, so the list and the
            // loading flag they set would not render until something else triggered one.
            const pLabels = withinTime(() => $scope.TasksAPI.queryTaskLabels(), "labels");
            const pUsers = withinTime(() => $scope.TasksAPI.getUsers(), "users");
            const pBasics = $q.all([pLabels, pUsers]).then((values) => {
                if (!values[0] || !values[1]) {
                    // Without the practices' labels and people there is no list to draw
                    return $q.reject();
                }
                if (generation !== loadGeneration) {
                    return;
                }
                setLabels(values[0].data);
                setUsers(values[1].data);
                ready = true;
                draw();
            });
            const pAssignedTasks = $q.resolve().then(() => loopPages(fetchAssignedTasks, "assignedTasks", dueDateWindow.start, dueDateWindow.end, generation, draw));
            const pCreatedTasks = $q.resolve().then(() => loopPages(fetchCreatedTasks, "createdTasks", dueDateWindow.start, dueDateWindow.end, generation, draw));

            $q.all([pBasics, pAssignedTasks, pCreatedTasks])
                .then(() => {
                    if (generation !== loadGeneration) {
                        return;
                    }
                    const late = [stalled.assigned && "tasks assigned to you", stalled.practice && "tasks raised in your practices"].filter(Boolean);
                    if (late.length) {
                        showError("The " + late.join(" and ") + " took too long to load, so some may be missing. Close the list and open it again to try again.");
                    }
                })
                .catch(() => {
                    if (generation !== loadGeneration) {
                        return;
                    }
                    if ($scope.state.loaded) {
                        showError("Not every task could be loaded. Close the list and open it again to try again.");
                    } else {
                        $scope.state.error = "The tasks couldn't be loaded.";
                    }
                })
                .finally(() => {
                    if (generation === loadGeneration) {
                        $scope.state.loading = false;
                    }
                });
        }

        $scope.reload = fetchTaskList;

        // Folds the two fetched pages of tasks into one list. A task the user both created and is
        // assigned comes back from both queries, so the created copy replaces the assigned one.
        // One copy of each task, too, should a page come back twice: the list is keyed by task id, and a
        // repeat would stop it drawing at all.
        function mergeFetchedTasks() {
            const byId = {};
            const order = [];
            [...$scope.assignedTasks, ...$scope.createdTasks].forEach((t) => {
                if (!byId[t.task_id]) {
                    order.push(t.task_id);
                }
                byId[t.task_id] = t;
            });
            $scope.allTasks = order.map(id => byId[id]);
            $scope.TOTAL_TASKS = angular.copy($scope.allTasks);
        }

        // The due-date window both task queries are bounded by. Live patches are held to the same
        // window, so a task due outside it cannot be added to a list a refresh would leave out.
        function taskDateWindow() {
            return {
                start: moment().add(-100, "d").utc().toISOString(),
                end: moment().add(100, "d").utc().toISOString(),
            };
        }

        // A task list open while someone else changes a task. This list is practice-wide, so any task
        // change in the user's practices can belong on it - unlike the nav badge, which only counts
        // their own. The one changed task is fetched; users and labels are left alone, because the
        // create/edit form is bound to them and swapping those out mid-edit would reset selections.
        TaskLiveUpdateService.subscribe($scope, {
            assignedTasks: function () {
                return $scope.assignedTasks;
            },
            practiceTasks: function () {
                return $scope.createdTasks;
            },
            window: taskDateWindow,
            isRelevant: function () {
                return true;
            },
            onChanged: function () {
                mergeFetchedTasks();
                mapTasks();
                filterLabels($scope.selectedPractice.map(t => t.id));
                rebuildList();
            },
        });

        function mapTasks() {
            $scope.allTasks = $scope.TOTAL_TASKS.filter((a) => $scope.selectedPractice.some((m) => m.id === a.practice_id)).map((t) => {
                const label = $scope.ALL_LABELS.find((m) => m.task_label_id === t.task_label_id);
                if (label) {
                    return { ...t, bgColor: "#" + label.colour, labelName: label.name };
                }
                return { ...t };
            });
        }

        function updateBadgeCount() {
            if ($scope.updateBadge) {
                $scope.updateBadge($scope.TOTAL_TASKS.filter(t => t.assigned_to_user_id === Session.user.id && !t.is_completed).length);
            }
        }

        // $scope.users holds one row per user per practice, so a user in several practices appears several
        // times. Prefer the row for the practice the task is assigned to (assigned_to_practice_id, which can
        // differ from the practice_id it was created in), and only fall back to any row for that user.
        function findUser(id, practiceId) {
            if (!$scope.users) {
                return null;
            }
            return $scope.users.find((t) => t.value === id && t.practiceId === practiceId)
                || $scope.users.find((t) => t.value === id)
                || null;
        }

        // Who a task is with, by name, as the waitlist shows its surgeons. Someone the users list doesn't have -
        // made inactive since, or not in a role tasks are listed for - goes by the name saved on the task.
        function assigneeOf(task) {
            if (!task.assigned_to_user_id) {
                return { key: "none", name: "Unassigned" };
            }
            const user = findUser(task.assigned_to_user_id, task.assigned_to_practice_id);
            return {
                key: String(task.assigned_to_user_id),
                name: user ? user.person : task.assigned_to_user_full_name || "Unknown user",
                isMe: task.assigned_to_user_id === Session.user.id,
            };
        }

        // The body of a task update: the task as it was loaded, with the changes over it. The list's own
        // working fields ($-prefixed) are left out; the rest goes as it always has.
        function requestBody(task, changes) {
            const body = {};
            Object.keys(task).forEach((key) => {
                if (key.charAt(0) !== "$") {
                    body[key] = task[key];
                }
            });
            return { ...body, ...changes };
        }

        // A saved change applied to every copy of the task, so a live update or a practice switch that
        // rebuilds the list from the fetched pages does not bring the old values back.
        function patchTask(taskId, changes) {
            [$scope.TOTAL_TASKS, $scope.assignedTasks, $scope.createdTasks].forEach((list) => {
                (list || []).forEach((t) => {
                    if (t.task_id === taskId) {
                        angular.extend(t, changes);
                    }
                });
            });
            mapTasks();
            rebuildList();
        }

        function removeTask(taskId) {
            const keep = (t) => t.task_id !== taskId;
            $scope.TOTAL_TASKS = $scope.TOTAL_TASKS.filter(keep);
            $scope.assignedTasks = ($scope.assignedTasks || []).filter(keep);
            $scope.createdTasks = ($scope.createdTasks || []).filter(keep);
            mapTasks();
            rebuildList();
        }

        // =================================================================
        // The list: tab, filters and sort
        // =================================================================

        // Newest first: outstanding work by when it was raised, finished work by when it was finished.
        // Both task queries come back by due date, so this order is something only the client does. Both
        // are UTC ISO strings, so a plain string sort is chronological. date_completed_UTC is only written
        // when a task is switched from open to completed, so older rows can carry none; the creation date
        // keeps those in a sensible order among themselves.
        const SORTS = {
            recent: (a, b) => {
                if ($scope.view.tab === "done") {
                    const done = compareText(a.date_completed_UTC, b.date_completed_UTC);
                    if (done) {
                        return done;
                    }
                }
                return compareText(a.date_created_UTC, b.date_created_UTC);
            },
            label: (a, b) => compareText(a.labelName, b.labelName),
            patient: (a, b) => compareText(a.patient_full_name, b.patient_full_name),
            assignee: (a, b) => compareText(a.$assignee.name, b.$assignee.name),
            due: (a, b) => compareText(a.date_due_UTC, b.date_due_UTC),
        };

        // The Sort menu: each option a sort and its direction. Each tab starts at newest first.
        $scope.SORT_OPTIONS = [
            { id: "newest", key: "recent", desc: true, label: "Newest first", doneLabel: "Recently completed" },
            { id: "oldest", key: "recent", desc: false, label: "Oldest first", doneLabel: "Completed longest ago" },
            { id: "due", key: "due", desc: false, label: "Due date" },
            { id: "patient", key: "patient", desc: false, label: "Patient" },
            { id: "label", key: "label", desc: false, label: "Label" },
            { id: "assignee", key: "assignee", desc: false, label: "Assigned to" },
        ];

        function sortFor(id) {
            const option = $scope.SORT_OPTIONS.find(o => o.id === id) || $scope.SORT_OPTIONS[0];
            return { id: option.id, key: option.key, desc: option.desc };
        }

        function compareText(a, b) {
            return String(a || "").localeCompare(String(b || ""), undefined, { sensitivity: "base" });
        }

        function matchesSearch(task, term) {
            if (!term) {
                return true;
            }
            return [task.patient_full_name, task.description, task.labelName, task.$assignee.name, task.user_full_name]
                .some((text) => text && text.toLowerCase().indexOf(term) !== -1);
        }

        // Everything the list draws is worked out here, once per change, rather than by functions the
        // template would call on every digest.
        function rebuildList() {
            const now = moment();
            $scope.allTasks.forEach((t) => {
                t.$assignee = assigneeOf(t);
                t.$overdue = !t.is_completed && !!t.date_due_UTC && !now.isBefore(moment.utc(t.date_due_UTC));
                t.$dueSoon = !t.is_completed && !t.$overdue && !!t.date_due_UTC && moment.utc(t.date_due_UTC).diff(now, "hours") < 48;
                // What the card's pickers show. A change not yet saved, or saving, is kept - the list is
                // rebuilt from fresh copies of the tasks, on a live update too - and checked again against
                // the task as it now is.
                const draft = picks[t.task_id];
                if (draft && (draft.dirty || $scope.fieldBusy[t.task_id] === "fields")) {
                    t.$pick = draft;
                    measurePick(t);
                } else {
                    t.$pick = picks[t.task_id] = pickOf(t);
                }
            });

            const open = $scope.allTasks.filter(t => !t.is_completed);
            const done = $scope.allTasks.filter(t => t.is_completed);
            $scope.counts = { open: open.length, done: done.length, overdue: open.filter(t => t.$overdue).length };
            const inTab = $scope.view.tab === "done" ? done : open;

            // Who the tab's tasks are with, for the rail. One entry per person, however many practices
            // they are in - the filter is by person. The signed-in user is always there, first, with
            // nothing to their name if that is so.
            const people = {};
            if ($scope.selectedPractice.length) {
                const me = String(Session.user.id);
                people[me] = { key: me, name: `${Session.user.firstName} ${Session.user.lastName}`, isMe: true, count: 0 };
            }
            inTab.forEach((t) => {
                const who = t.$assignee;
                if (!people[who.key]) {
                    people[who.key] = { key: who.key, name: who.name, isMe: who.isMe, count: 0 };
                }
                people[who.key].count++;
            });
            $scope.people = Object.values(people).sort((a, b) => {
                if (a.isMe !== b.isMe) return a.isMe ? -1 : 1;
                if (a.key === "none" || b.key === "none") return a.key === "none" ? 1 : -1;
                return compareText(a.name, b.name);
            });

            $scope.labelNames = $scope.labels
                .map(l => l.name)
                .filter((name, i, all) => all.indexOf(name) === i)
                .sort(compareText);

            // A filter left over from another practice's labels or people would hide everything.
            if ($scope.view.label && $scope.labelNames.indexOf($scope.view.label) === -1) {
                $scope.view.label = null;
            }

            const term = ($scope.view.search || "").trim().toLowerCase();
            const compare = SORTS[$scope.sort.key] || SORTS.recent;
            const direction = $scope.sort.desc ? -1 : 1;
            $scope.rows = inTab
                .filter(t => !$scope.view.assignee || t.$assignee.key === $scope.view.assignee)
                .filter(t => !$scope.view.label || t.labelName === $scope.view.label)
                .filter(t => matchesSearch(t, term))
                .sort((a, b) => direction * compare(a, b) || -SORTS.recent(a, b));

            updateBadgeCount();
        }

        function saveFilters() {
            $scope.SD.setTaskFilters({
                tab: $scope.view.tab,
                search: $scope.view.search,
                label: $scope.view.label,
                assignee: $scope.view.assignee,
            });
        }

        $scope.onFilterChange = function () {
            $scope.shown = PAGE_SIZE;
            rebuildList();
            saveFilters();
        };

        $scope.setTab = function (tab) {
            if ($scope.view.tab === tab) {
                return;
            }
            $scope.view.tab = tab;
            $scope.sort = sortFor("newest");
            // The people on one tab are not the people on the other
            $scope.view.assignee = "";
            $scope.onFilterChange();
        };

        $scope.setAssignee = function (key) {
            $scope.view.assignee = $scope.view.assignee === key ? "" : key;
            $scope.onFilterChange();
        };

        $scope.clearFilters = function () {
            $scope.view.search = "";
            $scope.view.label = null;
            $scope.view.assignee = "";
            $scope.onFilterChange();
        };

        $scope.hasFilters = function () {
            return !!($scope.view.search || $scope.view.label || $scope.view.assignee);
        };

        $scope.setSort = function (id) {
            $scope.sort = sortFor(id);
            rebuildList();
        };

        $scope.showMore = function () {
            if ($scope.shown < $scope.rows.length) {
                $scope.shown += PAGE_SIZE;
            }
        };

        // =================================================================
        // Practices
        // =================================================================
        $scope.isPracticeTicked = function (id) {
            return $scope.selectedPractice.some(p => p.id === id);
        };

        // Tick to add a practice alongside the others, or untick it - every one of them, current practice
        // included, as on the calendar. With none ticked the list says so.
        $scope.togglePractice = function (practice) {
            if ($scope.isPracticeTicked(practice.id)) {
                $scope.selectedPractice = $scope.selectedPractice.filter(p => p.id !== practice.id);
            } else {
                $scope.selectedPractice = [...$scope.selectedPractice, practice];
            }
            onPracticeUpdate();
        };

        $scope.onlyPractice = function (practice) {
            $scope.selectedPractice = [practice];
            onPracticeUpdate();
        };

        // "All practices", as on the calendar: ticks every practice, and clicked again with them all ticked,
        // unticks them all.
        $scope.isEveryPracticeTicked = function () {
            return $scope.practiceOptions.every(p => $scope.isPracticeTicked(p.id));
        };

        $scope.toggleAllPractices = function () {
            $scope.selectedPractice = $scope.isEveryPracticeTicked() ? [] : $scope.practiceOptions.slice();
            onPracticeUpdate();
        };

        // Each practice's colour, as the calendar marks it: the shared palette, in order of practice id
        const practiceColours = {};
        (Session.practiceOptions || []).map(p => p.id).sort((a, b) => Number(a) - Number(b))
            .forEach((id, index) => (practiceColours[String(id)] = PRACTICE_PALETTE[index % PRACTICE_PALETTE.length]));

        $scope.practiceColour = function (practiceId) {
            return practiceColours[String(practiceId)] || PRACTICE_PALETTE[0];
        };

        $scope.practiceName = function (id) {
            const practice = $scope.practices.find(p => p.id === id);
            return practice ? practice.name : "";
        };

        // Users and labels for every practice are already loaded, so changing practices only narrows them.
        function onPracticeUpdate() {
            filterLabels($scope.selectedPractice.map(t => t.id));
            mapTasks();
            $scope.view.assignee = "";
            $scope.shown = PAGE_SIZE;
            rebuildList();
            $scope.SD.setTaskFilters({ selectedPractice: $scope.selectedPractice });
            saveFilters();
        }

        // =================================================================
        // Formatting
        // =================================================================
        function practiceTimezone() {
            var practiceTimezoneName = (Session && Session.practice && Session.practice.timezone) || null;

            if (practiceTimezoneName && (!moment.tz || !moment.tz.zone(practiceTimezoneName))) {
                var candidate = Array.isArray($scope.TIMEZONE_TYPE)
                    ? $scope.TIMEZONE_TYPE.find(function (z) {
                        return z && (z.value === practiceTimezoneName || z.name === practiceTimezoneName);
                    })
                    : null;
                if (candidate && moment.tz.zone(candidate.name)) {
                    practiceTimezoneName = candidate.name;
                }
            }

            return practiceTimezoneName && moment.tz && moment.tz.zone(practiceTimezoneName) ? practiceTimezoneName : null;
        }

        $scope.formatDue = function (date, format) {
            if (date == null) return '';
            const zone = practiceTimezone();
            const at = zone ? moment.utc(date).tz(zone).toDate() : moment.utc(date).toDate();
            return $filter("date")(at, format || "dd/MM/yyyy");
        };

        $scope.isBeforeDue = function (date) {
            return moment().isBefore(moment.utc(date));
        }

        $scope.labelColour = function (taskLabelId) {
            const label = $scope.ALL_LABELS.find(t => t.task_label_id === taskLabelId);
            return label ? "#" + label.colour : null;
        };

        // =================================================================
        // Completing, editing and deleting
        // =================================================================

        // Not applied until the server has it: the toggle spins meanwhile, and a failure leaves the task
        // as it was and says so above the list. Once saved the tick turns green - or clears - and the card
        // lingers before moving to the other tab.
        const settleTimers = {};

        $scope.toggleComplete = function (task, $event) {
            if ($event) {
                $event.stopPropagation();
            }
            if (!task || $scope.busy[task.task_id] || $scope.settling[task.task_id] !== undefined) {
                return;
            }
            const taskId = task.task_id;
            const completing = !task.is_completed;
            const changes = { is_completed: completing };
            $scope.busy[taskId] = true;
            $scope.TasksAPI.updateTask(taskId, task.practice_id, requestBody(task, changes))
                .then(
                    function () {
                        // The server stamps the completion date; this copy only keeps the Completed tab's
                        // order right until the next load brings the real one.
                        const apply = () => patchTask(taskId, completing ? { ...changes, date_completed_UTC: new Date().toISOString() } : changes);
                        $scope.settling[taskId] = completing;
                        settleTimers[taskId] = $timeout(function () {
                            delete $scope.settling[taskId];
                            delete settleTimers[taskId];
                            apply();
                        }, 900);
                    },
                    function () {
                        showError("That task couldn't be " + (completing ? "completed" : "reopened") + ". Try again.");
                    }
                )
                .finally(function () {
                    delete $scope.busy[taskId];
                });
        };

        // Only a failure is announced beside the list, and it stays until dismissed. A change that worked
        // shows on the control that made it.
        function showError(text) {
            $scope.notice = { type: "error", text: text };
        }

        $scope.dismissNotice = function () {
            $scope.notice = null;
        };

        // A box that grows with what is written in it, so it is never taller or shorter than the text
        // A browser that sizes a box to its text itself (field-sizing, in the stylesheet) is left to; others are
        // measured. Either way the box starts with a row per line written, up to twelve, so it is never one
        // line high for a long text even before - or without - being measured.
        const SIZES_ITSELF = !!(window.CSS && CSS.supports && CSS.supports("field-sizing", "content"));

        function fitBox(box) {
            if (SIZES_ITSELF) {
                box.style.height = "";
                return;
            }
            box.style.height = "auto";
            box.style.height = Math.max(box.scrollHeight, box.clientHeight) + 2 + "px";
        }

        $scope.boxRows = function (text) {
            return Math.min(12, Math.max(1, String(text || "").split("\n").length));
        };

        // Focus a box opened to write in, with the cursor after what is there and the box sized to it. Done
        // straight after the digest that puts the box on the page - before the browser draws it, so it never
        // shows at the wrong height - and without the second full digest a $timeout would cost.
        function openBox(id) {
            $scope.$$postDigest(() => {
                const box = document.getElementById(id);
                if (box) {
                    fitBox(box);
                    refitOnResize(box);
                    box.focus();
                    box.setSelectionRange(box.value.length, box.value.length);
                }
            });
        }

        // The box first appears beside the description it replaces, which ngAnimate only takes away a frame or
        // so later, so it is sized at the wrong width: too tall once it widens, or a single line if it had no
        // width yet. Sized again whenever its width changes, for as long as it is open.
        let boxObserver = null;
        function refitOnResize(box) {
            if (boxObserver) {
                boxObserver.disconnect();
                boxObserver = null;
            }
            if (typeof ResizeObserver !== "function") {
                requestAnimationFrame(() => requestAnimationFrame(() => fitBox(box)));
                return;
            }
            let width = box.clientWidth;
            const observer = new ResizeObserver(() => {
                if (!box.isConnected) {
                    observer.disconnect();
                    return;
                }
                if (box.clientWidth !== width) {
                    width = box.clientWidth;
                    fitBox(box);
                }
            });
            observer.observe(box);
            boxObserver = observer;
        }

        // Saved, a change shows on the control that made it for a moment
        function flashSaved(taskId, what) {
            $scope.fieldSaved[taskId] = what;
            $timeout(() => {
                if ($scope.fieldSaved[taskId] === what) {
                    delete $scope.fieldSaved[taskId];
                }
            }, 2000);
        }

        // =================================================================
        // A card's pickers: label, practice, person and due date
        // =================================================================

        // Each card's pickers, by task id. They hold a change until Save, as the practice and the person there
        // go together - the backend checks one against the other - and a label goes with the practice.
        const picks = {};

        function assignedPracticeOf(task) {
            return task.assigned_to_practice_id || task.practice_id;
        }

        // The day a task is due, as its card shows it, for the date picker: midnight of that day, local time
        function dueDayOf(task) {
            if (!task.date_due_UTC) {
                return null;
            }
            const zone = practiceTimezone();
            const due = zone ? moment.utc(task.date_due_UTC).tz(zone) : moment.utc(task.date_due_UTC).local();
            return moment(due.format("YYYY-MM-DD"), "YYYY-MM-DD").toDate();
        }

        function dayKey(date) {
            return date ? moment(date).format("YYYY-MM-DD") : null;
        }

        function pickOf(task) {
            return {
                label: task.task_label_id,
                practice: assignedPracticeOf(task),
                user: task.assigned_to_user_id,
                due: dueDayOf(task),
                changes: {},
                dirty: false,
            };
        }

        // What Save would send, and whether there is anything to save
        function measurePick(task) {
            const pick = task.$pick;
            const changes = {};
            if (pick.label !== task.task_label_id) {
                changes.task_label_id = pick.label;
            }
            if (pick.practice !== assignedPracticeOf(task) || pick.user !== task.assigned_to_user_id) {
                changes.assigned_to_practice_id = pick.practice;
                changes.assigned_to_user_id = pick.user;
            }
            // A new due date is the start of the chosen day, as the new task form sends it
            const due = dayKey(pick.due);
            if (due !== dayKey(dueDayOf(task))) {
                changes.date_due_UTC = due ? moment(due, "YYYY-MM-DD").utc().toISOString() : null;
            }
            pick.changes = changes;
            pick.dirty = Object.keys(changes).length > 0;
        }

        // The labels a card offers: the ones of the practice it is assigned to, as the new task form offers
        // them - with the task's own label first if it is from elsewhere, so it still shows as chosen.
        // A practice's list with one more option first, made once and handed back unchanged on every digest
        // after. ng-options tracks its options by object identity, so a list made afresh each digest - its
        // extra option a new object every time - never settles: the digest runs until AngularJS gives up
        // (infdig), and the page stops updating.
        const withFirstCache = {};

        function withFirst(key, options, makeFirst) {
            const kept = withFirstCache[key];
            if (kept && kept.options === options) {
                return kept.list;
            }
            const list = [makeFirst(), ...options];
            withFirstCache[key] = { options: options, list: list };
            return list;
        }

        $scope.labelOptions = function (task) {
            const pick = task.$pick;
            const options = labelsByPractice[pick.practice] || NONE;
            if (!pick.label || options.some(l => l.task_label_id === pick.label)) {
                return options;
            }
            const current = $scope.ALL_LABELS.find(l => l.task_label_id === pick.label);
            return current ? withFirst("label:" + pick.practice + ":" + pick.label, options, () => current) : options;
        };

        // The people a card offers: those at the practice picked, with whoever has the task first if the
        // users list doesn't have them, so they still show as chosen.
        $scope.userOptions = function (task) {
            const pick = task.$pick;
            const options = usersByPractice[pick.practice] || NONE;
            if (!pick.user || options.some(u => u.value === pick.user)) {
                return options;
            }
            return withFirst("user:" + pick.practice + ":" + pick.user, options, () => ({ value: pick.user, name: task.$assignee.name }));
        };

        // A new practice keeps the person if they are there too, and the label if that practice has one of
        // the same name; otherwise the picker asks for one there.
        $scope.onPickChange = function (task, what) {
            const pick = task.$pick;
            if (what === "practice" && pick.practice === assignedPracticeOf(task)) {
                // Back to the practice it was: anything the move cleared comes back as it was
                pick.user = pick.user || task.assigned_to_user_id;
                const original = $scope.ALL_LABELS.find(l => l.task_label_id === task.task_label_id);
                const picked = $scope.ALL_LABELS.find(l => l.task_label_id === pick.label);
                if (!picked || (original && original.name === picked.name)) {
                    pick.label = task.task_label_id;
                }
            } else if (what === "practice") {
                if (!$scope.usersForPractice(pick.practice).some(u => u.value === pick.user)) {
                    pick.user = null;
                }
                const labels = labelsByPractice[pick.practice] || NONE;
                if (!labels.some(l => l.task_label_id === pick.label)) {
                    const was = $scope.ALL_LABELS.find(l => l.task_label_id === pick.label);
                    const same = was && labels.find(l => l.name === was.name);
                    pick.label = same ? same.task_label_id : null;
                }
            }
            measurePick(task);
        };

        // The due date: a button that opens the browser's date picker, as the waitlist's surgery date does
        $scope.pickDue = function ($event, task) {
            $event.stopPropagation();
            const input = $event.currentTarget.parentNode.querySelector("input[type=date]");
            if (input && typeof input.showPicker === "function") {
                try {
                    input.showPicker();
                    return;
                } catch (e) {
                    // Not allowed here - show the input itself instead
                }
            }
            $scope.typingDue[task.task_id] = true;
            $timeout(() => input && input.focus());
        };

        $scope.canSavePick = function (task) {
            const pick = task.$pick;
            return pick.dirty && !!pick.label && !!pick.user && !!pick.due && !$scope.fieldBusy[task.task_id];
        };

        $scope.savePick = function (task) {
            if (!$scope.canSavePick(task)) {
                return;
            }
            saveTask(task, task.$pick.changes, "fields").then((ok) => {
                if (ok) {
                    delete $scope.typingDue[task.task_id];
                }
            });
        };

        $scope.cancelPick = function (task) {
            delete $scope.typingDue[task.task_id];
            task.$pick = picks[task.task_id] = pickOf(task);
        };

        function saveTask(task, changes, what) {
            const taskId = task.task_id;
            $scope.fieldBusy[taskId] = what;
            delete $scope.fieldSaved[taskId];
            return $scope.TasksAPI.updateTask(taskId, task.practice_id, requestBody(task, changes))
                .then(
                    function () {
                        delete $scope.fieldBusy[taskId];
                        // Saved, the pickers start again from the task. A failed save keeps them as they
                        // are, to try again.
                        if (what === "fields") {
                            delete picks[taskId];
                        }
                        patchTask(taskId, changes);
                        flashSaved(taskId, what);
                        return true;
                    },
                    function () {
                        delete $scope.fieldBusy[taskId];
                        showError("That change couldn't be saved. Try again.");
                        return false;
                    }
                );
        }

        // The description, written on the card. One at a time; one part-written is kept rather than lost.
        function descriptionDirty() {
            const edit = $scope.descEdit;
            const task = edit && $scope.allTasks.find(t => t.task_id === edit.id);
            return !!edit && (edit.text || "") !== ((task && task.description) || "");
        }

        $scope.editDescription = function (task, $event) {
            $event.stopPropagation();
            if ($scope.descEdit && $scope.descEdit.id !== task.task_id && descriptionDirty()) {
                openBox("wlDesc-" + $scope.descEdit.id);
                return;
            }
            $scope.descEdit = { id: task.task_id, text: task.description || "" };
            openBox("wlDesc-" + task.task_id);
        };

        $scope.fitDescription = function (taskId) {
            const box = document.getElementById("wlDesc-" + taskId);
            if (box) {
                fitBox(box);
            }
        };

        $scope.cancelDescription = function () {
            $scope.descEdit = null;
        };

        $scope.saveDescription = function (task) {
            const edit = $scope.descEdit;
            if (!edit || edit.id !== task.task_id || $scope.fieldBusy[task.task_id] || !descriptionDirty()) {
                return;
            }
            saveTask(task, { description: edit.text }, "description").then((ok) => {
                if (ok && $scope.descEdit === edit) {
                    $scope.descEdit = null;
                }
            });
        };

        // Clicking away saves what was written - or, with nothing changed, just closes the box. Moving to the
        // box's own buttons is not leaving it, and pressing them doesn't take focus from it (their mousedown is
        // stopped), so Cancel still cancels.
        $scope.onDescriptionBlur = function (task, $event) {
            const edit = $scope.descEdit;
            const form = $event.target.form;
            if (!edit || edit.id !== task.task_id || $scope.fieldBusy[task.task_id]
                || (form && $event.relatedTarget && form.contains($event.relatedTarget))) {
                return;
            }
            if (descriptionDirty()) {
                $scope.saveDescription(task);
            } else {
                $scope.cancelDescription();
            }
        };

        // Ctrl/Cmd + Enter saves; Escape puts the description back, without closing the whole list
        $scope.onDescriptionKey = function ($event, task) {
            if ($event.key === "Escape") {
                $event.preventDefault();
                $event.stopPropagation();
                $scope.cancelDescription();
            } else if ($event.key === "Enter" && ($event.ctrlKey || $event.metaKey)) {
                $event.preventDefault();
                $scope.saveDescription(task);
            }
        };

        // Only a completed task can be deleted, and only after confirming on the card
        $scope.deleteTask = function (task) {
            const taskId = task.task_id;
            if ($scope.fieldBusy[taskId] || !task.is_completed) {
                return;
            }
            $scope.fieldBusy[taskId] = "delete";
            // deleteTask takes (practiceId, taskId).
            $scope.TasksAPI.deleteTask(task.practice_id, taskId)
                .then(
                    function () {
                        removeTask(taskId);
                    },
                    function () {
                        showError("The task couldn't be deleted. Try again.");
                    }
                )
                .finally(function () {
                    delete $scope.fieldBusy[taskId];
                    delete $scope.confirmDelete[taskId];
                });
        };

        // =================================================================
        // Creating a task
        // =================================================================
        function fetchUsers(callback) {
            $scope.TasksAPI.isProcessing = true;

            $scope.TasksAPI.getUsers().then(function (resp) {
                setUsers(resp.data);
            }, function () {
                $scope.createError = "The practice's users couldn't be loaded. Close this and try again.";
            }).then(function () {
                $scope.TasksAPI.isProcessing = false;
                if (callback) {
                    callback();
                }
                $scope.filterOptions();
            });
        }

        function fetchLabels() {
            // create task
            $scope.TasksAPI.isProcessing = true;
            $scope.TasksAPI.queryTaskLabels().then(function (resp) {
                setLabels(resp.data);
                $scope.onPracticeChange();
            }, function () {
                $scope.createError = "The task labels couldn't be loaded. Close this and try again.";
            }).then(function () {
                $scope.TasksAPI.isProcessing = false;
            })

        }

        function filterLabels(practiceIds) {
            $scope.labels = $scope.ALL_LABELS.filter(t => practiceIds.some(m => m === t.practice_id));
        }

        $scope.onPracticeChange = function () {
            filterLabels([$scope.taskForm.assigned_to_practice_id]);
            fetchUsers();
        }

        $scope.onAssignedToUserChange = function () {
            const id = $scope.taskForm.assigned_to_user_id;
            const target = $scope.users.find(t => t.value === id);
            if (target) {
                $scope.taskForm.assigned_to_practice_id = target.practiceId;
            }
        }

        $scope.setDuePreset = function (days) {
            $scope.taskForm.date_due_UTC = moment().add(days, "d").format("DD/MM/YYYY");
        };

        $scope.isDuePreset = function (days) {
            return $scope.taskForm.date_due_UTC === moment().add(days, "d").format("DD/MM/YYYY");
        };

        function transformDate(value) {
            const array = value.split('/');
            return array[2] + '-' + array[1] + '-' + array[0];
        }

        $scope.createTask = function (form) {
            if ($scope.isCreatingTask) {
                // A second click while the first create is in flight would create a duplicate task.
                return;
            }
            if ((form && form.$invalid) || !$scope.taskForm.date_due_UTC || !$scope.taskPatient) {
                // Each missing field says so beside itself once the form has been submitted.
                return;
            }
            const date_due_UTC = moment(transformDate($scope.taskForm.date_due_UTC)).utc().toISOString();
            const data = {
                ...$scope.taskForm,
                is_completed: false,
                date_due_UTC: date_due_UTC,
                patient_id: $scope.taskPatient.id,
                practice_id: Session.practice.id,
                user_id: Session.user.id,
            };
            $scope.isCreatingTask = true;
            $scope.createError = null;
            $scope.TasksAPI.isProcessing = true;
            $scope.TasksAPI.createTask(data)
                .then(
                    function (resp) {
                        $scope.$mdDialog.hide();
                        if ($scope.notifyNav) {
                            $scope.notifyNav();
                        }
                    },
                    function (error) {
                        $scope.createError = "The task couldn't be created. Check the details and try again.";
                    }
                )
                .then(function () {
                    $scope.isCreatingTask = false;
                    $scope.TasksAPI.isProcessing = false;
                });
        }

        // =================================================================
        // Finding the patient for a new task: the patient search the calendar's booking uses (surname,
        // phone, email or NHI). Any patient it finds can be chosen; another practice's are labelled with it.
        // =================================================================
        let patientSearchSequence = 0;
        let patientListCloseTimer = null;

        function searchPatients(term) {
            const searchTerm = (term || "").trim();
            const requestId = ++patientSearchSequence;
            if (searchTerm.length < 2) {
                $scope.patientSearch = { results: [], searched: false, loading: false };
                return;
            }
            $scope.patientSearch.loading = true;
            PatientAPI.search("", "", searchTerm, "").then(
                function (resp) {
                    if (requestId !== patientSearchSequence) {
                        return;
                    }
                    $scope.patientPicker.active = -1;
                    $scope.patientSearch = {
                        searched: true,
                        loading: false,
                        results: (resp.data || []).map((p) => {
                            const born = p.dateOfBirth && moment(p.dateOfBirth).isValid() ? moment(p.dateOfBirth).locale("en") : null;
                            return {
                                id: p.id,
                                name: [p.firstName, p.lastName].filter(Boolean).join(" "),
                                dob: born ? born.format("DD/MM/YYYY") : "",
                                dobLabel: born ? born.format("D MMM YYYY") : "",
                                otherPractice: p.practice && p.practice.id !== Session.practice.id ? p.practice.name || "Another practice" : null,
                                needsReview: !!p.needs_review,
                            };
                        }),
                    };
                },
                function () {
                    if (requestId === patientSearchSequence) {
                        $scope.patientSearch = { results: [], searched: true, loading: false };
                    }
                }
            );
        }

        $scope.isPatientListOpen = function () {
            return $scope.patientPicker.open && ($scope.patientPicker.query || "").trim().length >= 2
                && ($scope.patientSearch.loading || $scope.patientSearch.searched);
        };

        // Typing again is a new search: whoever was chosen no longer matches what the field says.
        $scope.onPatientQueryChange = function () {
            $scope.taskPatient = null;
            $scope.patientPicker.open = true;
            searchPatients($scope.patientPicker.query);
        };

        // Escape with the list open closes only the list, not the whole dialog
        $scope.onPatientKeydown = function (event) {
            const results = $scope.patientSearch.results;
            if (event.key === "ArrowDown" || event.key === "ArrowUp") {
                event.preventDefault();
                if (!results.length) {
                    return;
                }
                $scope.patientPicker.open = true;
                const step = event.key === "ArrowDown" ? 1 : -1;
                $scope.patientPicker.active = ($scope.patientPicker.active + step + results.length) % results.length;
            } else if (event.key === "Enter") {
                // Never submits the form from here - Enter chooses the highlighted patient, if any.
                event.preventDefault();
                if ($scope.isPatientListOpen() && results[$scope.patientPicker.active]) {
                    $scope.choosePatient(results[$scope.patientPicker.active]);
                }
            } else if (event.key === "Escape" && $scope.isPatientListOpen()) {
                event.preventDefault();
                event.stopPropagation();
                $scope.patientPicker.open = false;
            }
        };

        // After a moment, so a click on a result (handled on mousedown) is not lost to the blur.
        $scope.closePatientList = function () {
            $timeout.cancel(patientListCloseTimer);
            patientListCloseTimer = $timeout(function () {
                $scope.patientPicker.open = false;
            }, 150);
        };

        $scope.choosePatient = function (patient) {
            if (patient.needsReview) {
                // A task can't be added to an imported patient until it is reviewed. Review it now, and carry
                // on with the patient it turns out to be - the existing patient, when it was a duplicate.
                $scope.patientPicker.open = false;
                PatientImportReview.open(patient.id)
                    .then(function (reviewed) {
                        const born = reviewed.dateOfBirth && moment(reviewed.dateOfBirth).isValid() ? moment(reviewed.dateOfBirth).locale("en") : null;
                        $scope.choosePatient({
                            id: reviewed.id,
                            name: [reviewed.firstName, reviewed.lastName].filter(Boolean).join(" "),
                            dob: born ? born.format("DD/MM/YYYY") : "",
                        });
                    })
                    .catch(angular.noop);
                return;
            }
            $scope.taskPatient = { id: patient.id, name: patient.name, dob: patient.dob };
            // The field shows who was chosen; setting the query here does not search again, since
            // ng-change only fires for typing.
            $scope.patientPicker.query = patient.name;
            $scope.patientPicker.open = false;
            $scope.patientPicker.active = -1;
        };

        $scope.clearPatient = function () {
            $scope.taskPatient = null;
            $scope.patientPicker = { query: "", open: false, active: -1 };
            $scope.patientSearch = { results: [], searched: false, loading: false };
            patientSearchSequence++;
        };

        // Opened for a patient, the task can still be for someone else
        $scope.changePatient = function () {
            $scope.clearPatient();
            $scope.pickingPatient = true;
            $scope.$$postDigest(() => {
                const field = document.getElementById("taskPatient");
                if (field) {
                    field.focus();
                }
            });
        };

        // =================================================================
        // Opening a patient
        // =================================================================
        function selectPatient(patient) {
            if ($scope.CP.patientBackup) {
                $scope.patientBackup = angular.copy($scope.CP.patientBackup);
            }
            $scope.CP.clearPatient();

            $timeout(function () {
                $scope.CP.setPatient(patient);

                if (!$scope.CP.patientIsMine) {
                    // Launch the new standalone transfer modal
                    $modal({
                        controller: "patientTransferController",
                        templateUrl: "app/src/views/templates/modal.patient-transfer-flow.tpl.html",
                        show: true,
                        backdrop: "static",
                        resolve: {
                            patientId: function () {
                                return patient.id;
                            },
                            onSuccess: function () {
                                return function (updatedPatient) {
                                    $scope.CP.setPatient(updatedPatient);
                                    $state.go("patient-dashboard");
                                    $mdDialog.hide();
                                };
                            },
                            onCancel: function () {
                                return function () {
                                    // Restore the backup if they cancel
                                    if ($scope.patientBackup) {
                                        $scope.CP.setPatient($scope.patientBackup);
                                    }
                                };
                            }
                        }
                    });
                } else {
                    $state.go("patient-dashboard");
                    $mdDialog.hide();
                }
            }, 50);
        };

        $scope.switchPatient = function (patientId, $event) {
            if ($event) {
                $event.stopPropagation();
            }
            if ($scope.CP.patient.id === patientId) {
                $mdDialog.hide();
                $state.go("patient-dashboard");
                return;
            }
            $scope.PA.isProcessing = true;
            $scope.PA.getPatient(patientId).then(function (resp) {
                selectPatient(resp.data);
            }, function () {
                showError("That patient couldn't be opened. Try again.");
            }).then(function () {
                $scope.PA.isProcessing = false;
            });
        }

        // For the patient open, if there is one; otherwise the new task form finds one
        $scope.createTaskForPatient = function () {
            if ($scope.createNewTask) {
                $mdDialog.hide();
                const current = $scope.CP.patient && $scope.CP.patient.id ? $scope.CP.patient : null;
                const patient = current ? {
                    patientName: current.firstName + ' ' + current.lastName,
                    dob: current.dateOfBirth,
                    patientId: current.id,
                } : { patientName: "", dob: "", patientId: null };
                $scope.createNewTask(patient);
            }
        }

        $scope.$on("$destroy", function () {
            Object.keys(settleTimers).forEach(id => $timeout.cancel(settleTimers[id]));
            $timeout.cancel(patientListCloseTimer);
            if (boxObserver) {
                boxObserver.disconnect();
            }
        });
    },
]);
